import { assert, subTestContext, Test } from "oc-e2e-testrunner";
import {
  assertAlleElementeSap,
  assertElementZwischenMauern,
  assertSegmentIstLückenlosGefüllt,
  assertWarnungen,
  resetArrangement,
} from "./utils";
import { setEmptyAsMauer } from "../components/zauneditor/ZaunCircleMenuItemEmptyAsMauer";
import { FormType } from "../arrangement/Grundriss";
import { getTypeNameOfPart } from "../arrangement/arrangementFunctions";

export default {
  name: "TestInsertAndRemoveMauer",
};

export const testMauerInGefüllterStreckeLückenlosLinks: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [7]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  // @ts-ignore
  _.first(s.getElemente()).uiRemove();
  agt.update3d();
  setEmptyAsMauer(s.empties[0]);
  agt.update3d();
  assertSegmentIstLückenlosGefüllt(agt.segmente[0]);
  assertAlleElementeSap(agt.segmente[0].getElemente(), -1);
};

export const testMauerInGefüllterStreckeLückenlosRechts: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [7]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  // @ts-ignore
  _.last(s.getElemente()).uiRemove();
  agt.update3d();
  setEmptyAsMauer(s.empties[0]);
  agt.update3d();
  assertSegmentIstLückenlosGefüllt(agt.segmente[0]);
  assertAlleElementeSap(agt.segmente[0].getElemente(), 1);
};

export const testMauerInGefüllterStreckeLückenlosMittig: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [7]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[Math.round(s.getElemente().length / 2)].uiRemove();
  agt.update3d();
  setEmptyAsMauer(s.empties[0]);
  agt.update3d();
  assertSegmentIstLückenlosGefüllt(agt.segmente[0]);
  assertSegmentIstLückenlosGefüllt(agt.segmente[1]);
  assertAlleElementeSap(agt.segmente[0].getElemente(), 1);
  assertAlleElementeSap(agt.segmente[1].getElemente(), -1);
};

export const testDoppeltorInMauer: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [7]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  // @ts-ignore
  s.getElemente()[0].uiRemove();
  s.getElemente()[1].uiRemove();
  agt.update3d();
  setEmptyAsMauer(s.empties[0]);
  setEmptyAsMauer(s.empties[1]);
  s.getElemente()[0].uiRemove();
  agt.update3d();
  APP.arrangement.setSelectedObjects(s.empties);
  agt.update3d();
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Doppeltor_Easy");
  agt.changeSelectedZaunElemente({
    massAuswahlwert,
  });
  assertElementZwischenMauern(s.getElemente()[0]);
  assertSegmentIstLückenlosGefüllt(s);
};

export const testMauerErsetzenMitElement: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [8]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[3].uiRemove();
  agt.update3d();
  setEmptyAsMauer(s.empties[0]);
  agt.update3d();
  agt.setSelectedObjects(agt.aufbauten);
  await agt.changeSelectedZaunElemente({
    massAuswahlwert: agt.massAuswahlwert,
    füllungAuswahlwert: agt.füllungAuswahlwert,
  });
  assert.equals(1, agt.segmente.length);
  assertSegmentIstLückenlosGefüllt(agt.segmente[0], false);
  assertWarnungen(agt, []);
};

export const testEinfügenMauerEcke: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Rechteck", [7, 7]);
  agt.fillIndividuellSegmentsWithElements();
  const element = agt.getEckpfosten()[0].elemente[0];
  const s = element.segment;
  element.uiRemove();
  agt.update3d();
  setEmptyAsMauer(agt.getEmpties()[0]);
  agt.update3d();
  assertSegmentIstLückenlosGefüllt(s, false);
  assertWarnungen(agt, []);
};

export const testEinfügenMauerEckeKlein: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Rechteck", [3, 3]);
  agt.fillIndividuellSegmentsWithElements();
  const element = agt.getEckpfosten()[0].elemente[0];
  const s = element.segment;
  element.uiRemove();
  agt.update3d();
  setEmptyAsMauer(agt.getEmpties()[0]);
  agt.update3d();
  assertSegmentIstLückenlosGefüllt(s, false);
  assertWarnungen(agt, []);
};

export const testEinfügenMauerEckeUndLöschenMauer: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Rechteck", [7, 7]);
  agt.fillIndividuellSegmentsWithElements();
  const element = agt.getEckpfosten()[0].elemente[0];
  const s = element.segment;
  element.uiRemove();
  agt.update3d();
  setEmptyAsMauer(agt.getEmpties()[0]);
  agt.update3d();
  assertSegmentIstLückenlosGefüllt(s, false);
  assertWarnungen(agt, []);
  agt.aufbauten = [];
  agt.update3d();
  assertWarnungen(agt, []);
};

const logBoxes = () =>
  APP.arrangement
    .getParts()
    .filter((p) => !p.isEmpty)
    .map((p, i) => ({
      id: p.id,
      type: p.meta?.Key ?? getTypeNameOfPart(p),
      box: p.getBox() + "",
    }));

export const testMauerInVerschiedenenPositionenUndFormenEntfernen: Test = async () => {
  const teste = async (form: FormType, laenge: number) => {
    let elementeLength = 1;
    for (let index = 0; index < elementeLength; index++) {
      if (
        !(await subTestContext(
          `entferne Mauer mit Index ${index} in ${form} ${laenge} m`,
          async () => {
            console.log(`entferne Mauer mit Index ${index} in ${form} ${laenge} m`);
            resetArrangement();
            const agt = APP.arrangement;
            agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("Individuell");
            agt.grundriss.setStandardForm(form, [laenge, laenge, laenge, laenge, laenge, laenge]);
            agt.fillIndividuellSegmentsWithElements();
            const elemente = agt.getElemente();
            elementeLength = elemente.length;
            if (index >= elementeLength) return false;
            agt.setSelectedObjects([elemente[index]]);
            agt.update3d();
            agt.removeSelectedObjects();
            agt.update3d();
            agt.setSelectedObjects(agt.getEmpties());
            agt.update3d();
            setEmptyAsMauer(agt.selectedObjects[0]);
            agt.update3d();
            const json = logBoxes();
            agt.setSelectedObjects(agt.aufbauten);
            agt.update3d();
            agt.removeSelectedObjects();
            agt.update3d();
            assert.deepEquals(json, logBoxes());
            return true;
          }
        ))
      )
        break;
    }
  };
  await teste("Strecke", 7);
  await teste("Rechteck", 5);
};
